<template>
  <div class="company-info">
    <div class="mod-title" v-if="showTitle">
      <span class="main">企业文化</span><span class="en">company</span>
    </div>
    <div class="info-box">
      <div class="left">
        <!--        <div class="base-info">-->
        <!--          <div class="base-box">-->
        <!--            <div class="num">{{info.peopleNum}}<span class="unit">人</span></div>-->
        <!--            <div class="type">公司员工</div>-->
        <!--          </div>-->
        <!--          <div class="base-box">-->
        <!--            <div class="num">{{info.projectNum}}<span class="unit">个</span></div>-->
        <!--            <div class="type">项目数量</div>-->
        <!--          </div>-->
        <!--          <div class="base-box">-->
        <!--            <div class="num">{{info.money}}<span class="unit">万元</span></div>-->
        <!--            <div class="type">项目金额</div>-->
        <!--          </div>-->
        <!--        </div>-->
        <div class="w-e-text-container">
          <div class="content-box" v-html="info.content" data-slate-editor></div>
        </div>
      </div>
      <div class="right" v-if="showRight">
        <div class="contact-box">
          <div class="title">
            <span class="icon icon-phone icon-mid"></span>
            <span>联系方式</span>
          </div>
          <ul>
            <li>{{ companyInfo.fullName }}</li>
            <li><span class="icon icon-location icon-mini"></span>地址：{{ contact.addr }}</li>
            <li><span class="icon icon-info icon-mini"></span>邮编：{{ contact.post }}</li>
            <li><span class="icon icon-phone01 icon-mini"></span>电话：{{ contact.workPhone }}</li>
            <li><span class="icon icon-location icon-mini"></span>传真：{{ contact.fax }}</li>
            <li><span class="icon icon-info icon-mini"></span>邮箱：{{ contact.mail }}</li>
            <li><span class="icon icon-info icon-mini"></span>商务洽谈：{{ contact.business }}</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {get} from '@/util/Http';
import {INFO} from '@/util/const';

export default {
  name: 'CompanyInfo',
  props: ['showRight', 'showTitle'],
  data() {
    return {
      companyInfo: INFO,
      info: {
        money: 0,
        peopleNum: 0,
        projectNum: 0,
        content: '',
      },
      contact: {
        addr: '',
        post: '',
        workPhone: '',
        fax: '',
        mail: '',
        business: '',
      },
    };
  },
  created() {
    this.getCompanyInfo();
    this.getCompanyContact();
  },
  methods: {
    getCompanyInfo() {
      get('/getCompanyInfo')
        .then((result) => {
          if (result.status === 200) {
            this.info = result.data.info;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getCompanyContact() {
      get('/getCompanyContact')
        .then((result) => {
          if (result.status === 200) {
            this.contact = result.data.contact;
          }
        }).catch((error) => {
        console.log(error);
      });
    },
  },
};
</script>

<style lang="less">

.contact-box {
  z-index: 2;
}

</style>
<style src="@wangeditor/editor/dist/css/style.css"></style>
